import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GameInstance, BattleShipGameState, GameMove, BattleShipMove } from '../types/types';
import { createGame } from '../services/gamesService';
import useUserContext from './useUserContext';

const useBattleshipGamePage = (gameInstance: GameInstance<BattleShipGameState>) => {
  const { user, socket } = useUserContext();
  const navigate = useNavigate();
  const opponentUsername =
    gameInstance.state.player1 === user.username
      ? (gameInstance.state.player2 as string)
      : (gameInstance.state.player1 as string);
  const [, setMove] = useState<string>('');
  const [selectedCell, setSelectedCell] = useState<string>('');

  const handleCellClick = (row: number, col: number) => {
    setSelectedCell(`${row},${col}`);
    setMove(`${row},${col}`);
  };

  const handleMakeMove = async () => {
    const [row, col] = selectedCell.split(',').map(Number); // Convert the selected cell to row/col
    const battleshipMove: GameMove<BattleShipMove> = {
      playerID: user.username,
      gameID: gameInstance.gameID,
      move: {
        row,
        col,
      },
    };

    // Emit the move
    socket.emit('makeMove', {
      gameID: gameInstance.gameID,
      move: battleshipMove,
    });
  };
  const handleResetGame = async () => {
    const newGameInstance = await createGame('BattleShip', true);
    socket.emit('resetGame', gameInstance.gameID, newGameInstance.toString());
    navigate(`/games/${newGameInstance.toString()}`);
  };

  useEffect(() => {
    const handleResetGameUpdate = (newRoom: string) => {
      navigate(`/games/${newRoom}`);
    };

    socket.on('serverResetGame', handleResetGameUpdate);

    return () => {
      socket.off('serverResetGame', handleResetGameUpdate);
    };
  }, [gameInstance, navigate, socket]);
  return {
    user,
    opponentUsername,
    selectedCell,
    handleCellClick,
    handleMakeMove,
    handleResetGame,
  };
};

export default useBattleshipGamePage;
